

//Stripe
//export const STRIPE_PK = "pk_test_51H2bODI7Mx4gzQe3DXxpk572S8TblmnuSiaTV3B6wBr2c6GAS66JwKIjSix3AJr8aSCUPZIHaz4XM5Y6c6PANBd300PBQM7sdE";
export const STRIPE_PK = "pk_live_51H2bODI7Mx4gzQe3wyhQsjNuptdtOZyvfeQA1cybQkI9HyKCsA9Ms33RTou6b7DZXPOISYJoU8CTVXtQYqIj9OdG00AI3cIMaC";

//CheckpointId Onboarding
export const CHECKPOINT_URL = "https://onboarding.checkpointid.com";
export const CHECKPOINT_TOKEN = "174b7a01-b8ed-42fa-477a-08d84933c1ad"; //*.behome247.com
//export const CHECKPOINT_TOKEN = "189423f0-bc0f-4ab4-a66f-08d8492261b3"; //ngrok
//export const CHECKPOINT_TOKEN = "cb1d0263-cb76-4e3d-62fd-08d84566937c"; //*.localhost
//export const CHECKPOINT_TOKEN = "f0cbf665-2c28-44d7-f09e-08d84de01022" //behome.behome247

//Checkpoint DVS
export const CHECKPOINT_DVS_URL = "https://dvs.checkpointid.com/api";
export const CHECKPOINT_PK = "pk_897068ef-a11b-42d9-8a03-a90bb53f41bc"; 

//BH Backend
export const BASE_URL = process.env.REACT_APP_API_BASE || "https://mf-prod.behome247.com";
export const BEHOME_URL = BASE_URL + "/api/v1"; 
export const BEHOME_MEDIA_URL = "https://behome247-mf.s3-us-west-2.amazonaws.com";

const DRIVER_LICENSE = 1;
const PASSPORT = 2;
const PASSPORT_CARD = 3;
const GREEN_CARD = 6;
const INTERNATIONAL = 7;

export const DocumentType = {
  DRIVER_LICENSE,
  PASSPORT,
  PASSPORT_CARD,
  GREEN_CARD,
  INTERNATIONAL
};

const OK = 0;
const FAKE = 1;
const DATA_ERROR = 2;
const SERVER_ERROR = 3;

export const DocumentStatus = {
	OK,
	FAKE,
	DATA_ERROR,
	SERVER_ERROR
};
